<template>
	<div>
		<v-alert v-if="!locumIsApproved" outlined color="red" type="info"
			>Your profile is currently being verified and will be <strong>processed within 2 business day</strong>. Fast track approval by getting in touch at
			<strong>hello@locumbase.com</strong>
			<br />
			<br />
			Go ahead and set your availability in the meantime 🙂
		</v-alert>

		<!-- Refactor to component -->
		<div v-if="tenant.settings.wallet.show">
			<v-btn block color="secondary" class="mb-4 hidden-md-and-up" @click="openWallet">
				<v-img :src="require('@/assets/images/LocumWallet logo_icon blue.png')" max-width="30" class="mr-2"></v-img>
				{{ getWallet.generalLabel }} R{{ getWallet.total }}
			</v-btn>
		</div>

		<component
			:is="call_for_actions.length == 0 ? 'locum-action-availability-card' : call_for_actions[0].component"
			:data="call_for_actions.legth > 0 ? call_for_actions[0].data : []"
			@dismiss="dismissNotification"
		/>

		<v-row no-gutters>
			<v-col class="pb-0" cols="12">
				<v-expansion-panels accordion :multiple="false" flat :elevation="1">
					<v-expansion-panel v-if="$vuetify.breakpoint.width < 1264">
						<v-expansion-panel-header color="#f6f6f6" class="font-weight-bold ma-0 pa-0"> Booking Calendar </v-expansion-panel-header>
						<v-expansion-panel-content color="#f6f6f6" class="panel-0-padding"><locum-dashboard-big-calendar /></v-expansion-panel-content>
					</v-expansion-panel>
					<locum-upcoming-bookings />
					<locum-booking-requests />
					<locum-offers-based-on-location />
					<locum-applications-sent />
					<locum-availabilities />
					<locum-un-availabilities />
					<locum-past-bookings />
				</v-expansion-panels>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import LocumActionAvailabilityCard from '@/components/ui/dashboard/locum/cards/LocumActionAvailabilityCard';

// Locum dropdown components
import LocumUpcomingBookings from '@/components/ui/dashboard/locum/dropdowns/LocumUpcomingBookings';
import LocumBookingRequests from '@/components/ui/dashboard/locum/dropdowns/LocumBookingRequests';
import LocumOffersBasedOnLocation from '@/components/ui/dashboard/locum/dropdowns/LocumOffersBasedOnLocation';
import LocumApplicationsSent from '@/components/ui/dashboard/locum/dropdowns/LocumApplicationsSent';
import LocumAvailabilities from '@/components/ui/dashboard/locum/dropdowns/LocumAvailabilities';
import LocumUnAvailabilities from '@/components/ui/dashboard/locum/dropdowns/LocumUnAvailabilities';
import LocumPastBookings from '@/components/ui/dashboard/locum/dropdowns/LocumPastBookings';

import LocumDashboardBigCalendar from '@/components/ui/dashboard/locum/LocumDashboardBigCalendar';

//called action cards :
import LocumAvailabilitySet from '@/components/ui/dashboard/locum/cards/LocumAvailabilitySet';
import LocumBookingConfirmed from '@/components/ui/dashboard/locum/cards/LocumBookingConfirmed';
import LocumAvailabilityDeleted from '@/components/ui/dashboard/locum/cards/LocumAvailabilityDeleted';
import LocumAvailabilityCreated from '@/components/ui/dashboard/locum/cards/LocumAvailabilityCreated';
import LocumAvailabilityUpdated from '@/components/ui/dashboard/locum/cards/LocumAvailabilityUpdated';
import LocumBookingRejected from '@/components/ui/dashboard/locum/cards/LocumBookingRejected';
import LocumApplicationSent from '@/components/ui/dashboard/locum/cards/LocumApplicationSent';

import { bus } from '@/main';
import store from '@/store';
import { Tracking } from '@/utils';

export default {
	name: 'LocumDashboardLandingZone',
	components: {
		LocumActionAvailabilityCard,
		LocumUpcomingBookings,
		LocumPastBookings,
		LocumApplicationsSent,
		LocumAvailabilities,
		LocumUnAvailabilities,
		LocumBookingRequests,
		LocumOffersBasedOnLocation,
		LocumDashboardBigCalendar,

		LocumAvailabilitySet,
		LocumBookingConfirmed,
		LocumAvailabilityDeleted,
		LocumAvailabilityCreated,
		LocumAvailabilityUpdated,
		LocumBookingRejected,
		LocumApplicationSent,
	},
	data: () => ({
		open: [],
	}),
	computed: {
		...mapGetters(['getWallet']),

		locumIsApproved() {
			return store.getters.user.approved;
		},
		call_for_actions() {
			return store.getters.getNotifications;
		},
	},
	mounted() {
		Tracking.track('LocumDashBoardDisplay', {});
		bus.$on('call-for-action', calledforaction => {
			if (!('component' in calledforaction) || !('data' in calledforaction)) {
				console.error("called for action with bad payload. Expected [string] 'component'. [Object] 'data' . Got :", calledforaction);
			} else {
				this.call_for_actions.push(calledforaction);
			}
		});
	},
	methods: {
		dismissNotification() {
			store.commit('POP_NOTIFICATION');
		},
		derp() {
			store.commit('PUSH_NOTIFICATION', { component: 'locum-availability-set', data: ['derpderp'] });
		},
		openWallet() {
			bus.$emit('show-wallet-dialog');
		},
	},
};
</script>
